"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerSelect = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _DatePickerButton = require("../DatePickerButton/DatePickerButton");
var _index = require("../Icon/index");
var _DatePickerSelect = require("./DatePickerSelect.styles");
var _excluded = ["children"];
/**
 * A `DatePickerSelect` is designed specifically for `DatePicker`.
 *
 * @related [`DatePicker`]
 * @since 8.0.0
 */

var DatePickerSelect = function DatePickerSelect(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_DatePickerSelect.StyledDatePickerSelect, null, /*#__PURE__*/_react.default.createElement("select", props, children), /*#__PURE__*/_react.default.createElement(_DatePickerButton.DatePickerButton, {
    tabIndex: "-1"
  }, /*#__PURE__*/_react.default.createElement(_index.IconPlay, null)));
};
exports.DatePickerSelect = DatePickerSelect;
DatePickerSelect.displayName = 'DatePickerSelect';
DatePickerSelect.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
DatePickerSelect.defaultProps = {
  children: null
};